module.exports = __webpack_public_path__ + "guernsey.svg?4243219022361e858691c1dab73df57f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/guernsey.svg
// module id = 181
// module chunks = 10